import $ from 'jquery';

const countErrorMessage = () => {
    const countErrorsElement = $('.sda-error').length;

    if (countErrorsElement > 1) {
        return `There are ${countErrorsElement} errors on this page, recheck your inputs please`;
    } else {
        return `There is ${countErrorsElement} error on this page, recheck your input please`;
    }
};

export default countErrorMessage;
